<!-- Translated: yes -->
<template>
  <div>
    {{message}}
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      message: '',
    };
  },
  mounted() {
    if (this.$route.params.pool) {
      setTimeout(() => {
        this.openModal(['SkiSchoolBooking', {
          pool: parseInt(this.$route.params.pool, 10),
          id: 0,
          activity: true,
        }]);
      }, 1);
    } else {
      this.message = this.$i18n.t('skischool.no-acitivities-found');
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ActivitiesPage.vue?b3ca259a